export const ID_SYSTEM_COMPANY = 1
